import { MapPin, Phone, MessageCircle, Navigation, Mail } from "lucide-react";
import useSeo from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";
import { MapEmbed, WHATSAPP_MSG, DIRECTIONS_URL } from "@/components/Floating";
import { HoursList } from "@/components/Footer";
import { FollowBar, SocialLinks } from "@/components/SocialFeeds";
import { useSite } from "@/context/SiteContext";
import { waLink } from "@/lib/api";
import { IMG } from "@/lib/catalog";
import { GoogleReviewQR } from "@/components/GoogleReviewQR";

export default function Contact() {
  useSeo("Contacto", "Taller de Suspensiones La Gringa: Calle 136 #715-A entre 133 y 135, Mérida, Yucatán 97306. Tel. y WhatsApp 999-191-9300.");
  const { site } = useSite() || {};
  const b = site?.business;
  return (
    <>
      <FollowBar />
      <PageHero eyebrow="Contacto" title="Estamos en Mérida" image={IMG.garage} subtitle="Llámanos, escríbenos por WhatsApp o visítanos directamente en el taller." />
      <section className="container-x grid gap-10 py-16 lg:grid-cols-[380px,1fr]">
        <div className="space-y-5">
          <div className="card-dark space-y-5 p-6">
            <p className="flex gap-3"><MapPin className="shrink-0 text-brand" /><span>{b?.address}</span></p>
            <a href="tel:+529991919300" className="flex gap-3 hover:text-brand" data-testid="contact-phone-link"><Phone className="text-brand" /> {b?.phone}</a>
            {b?.email && <a href={`mailto:${b.email}`} className="flex gap-3 hover:text-brand"><Mail className="text-brand" /> {b.email}</a>}
            <div className="flex flex-col gap-3 pt-2">
              <a href={waLink(b?.whatsapp || "529991919300", WHATSAPP_MSG)} target="_blank" rel="noopener noreferrer" className="btn-gold" data-testid="contact-whatsapp-btn"><MessageCircle size={18} /> Escribir por WhatsApp</a>
              <a href={DIRECTIONS_URL} target="_blank" rel="noopener noreferrer" className="btn-ghost" data-testid="contact-directions-btn"><Navigation size={16} /> Cómo llegar</a>
            </div>
            <SocialLinks />
          </div>
          <div className="card-dark p-6"><h2 className="eyebrow mb-4">Horario</h2><HoursList /></div>
        </div>
        <MapEmbed height={560} />
      </section>
      <GoogleReviewQR id="contact-qr" />
    </>
  );
}
